import { render, staticRenderFns } from "./SimulatorPage.vue?vue&type=template&id=dba1083e&"
import script from "./SimulatorPage.vue?vue&type=script&lang=js&"
export * from "./SimulatorPage.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports